export const sortAlphabeticalOrder = (item1: string, item2: string): number => {
	const valueA = item1.toLowerCase(),
		valueB = item2.toLowerCase();
	if (valueA < valueB) return -1;
	if (valueA > valueB) return 1;
	return 0;
};
